import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import './DocumentPage.css'

const CoreConcepts = () => {
  useEffect(() => {
    const headings = document.querySelectorAll('.doc-content h2, .doc-content h3')
    headings.forEach((heading) => {
      if (!heading.id) {
        heading.id = heading.textContent.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]/g, '')
      }
    })
  }, [])

  return (
    <div className="doc-page">
      <div className="doc-content">
        <h1>Core Concepts</h1>
        <p className="lead">
          Understand the fundamental concepts behind the Variable Modding System and CSV generation.
        </p>

        <h2>Overview</h2>
        <p>
          The Variable Modding System is built around the concept of data-driven design, allowing you to
          manage game variables through CSV files and data tables.
        </p>

        <h2>Key Topics</h2>
        <div style={{ marginTop: '2rem' }}>
          <h3><Link to="/core-concepts/csv-generation">CSV Generation</Link></h3>
          <p>
            Learn how the system generates and manages CSV files for your game variables, including
            import/export workflows and data validation.
          </p>
        </div>

        <h2>Fundamental Principles</h2>
        <h3>Data-Driven Design</h3>
        <p>
          The Variable Modding System embraces data-driven design principles, separating game logic
          from data configuration.
        </p>

        <h3>Type Safety</h3>
        <p>
          All variables are strongly typed, ensuring data integrity and preventing runtime errors.
        </p>

        <h3>Performance Optimization</h3>
        <p>
          Variables are cached and optimized for fast access during gameplay.
        </p>

        <h2>Common Use Cases</h2>
        <ul>
          <li>Game balance configuration</li>
          <li>Localization data management</li>
          <li>Item and inventory systems</li>
          <li>Character statistics and progression</li>
          <li>Environmental parameters</li>
        </ul>

        <h2>Best Practices</h2>
        <ul>
          <li>Keep CSV files organized and well-documented</li>
          <li>Use consistent naming conventions</li>
          <li>Version control your data tables</li>
          <li>Test changes thoroughly before deploying</li>
        </ul>
      </div>
    </div>
  )
}

export default CoreConcepts
